
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"-4 0 24 20","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1820:1545)"}},[_c('path',{attrs:{"d":"M17.341 3.128L15.284.878a2.157 2.157 0 00-1.591-.72h-1.318v4.306c0 .34-.252.615-.563.615h-9c-.31 0-.562-.275-.562-.615V.158H1.125C.504.158 0 .708 0 1.388v17.223c0 .68.504 1.23 1.125 1.23h15.75c.621 0 1.125-.55 1.125-1.23V4.868c0-.653-.237-1.278-.659-1.74zM15.75 17.381H2.25V10h13.5v7.38z"}}),_c('path',{attrs:{"d":"M10.125.158h-2.25v3.69h2.25V.159z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1820:1545"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .158)","d":"M0 0h18v19.683H0z"}})])])])
          )
        }
      }
    